import styled, { css } from 'styled-components'

type WrapperProps = {
  $hasNotification?: boolean
}

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 3.5rem;
  height: 3.5rem;
  margin-right: var(--spacer-4);
  border-radius: var(--border-radius);
  transition: background ease 250ms;
  position: relative;
  z-index: 1;

  ${({ $hasNotification }) =>
    $hasNotification &&
    css`
      &::before {
        background-color: var(--red) !important;
        content: '';
        width: 0.5rem;
        height: 0.5rem;
        border-radius: 50%;
        position: absolute;
        top: 0.5rem;
        right: 0.5rem;
      }
    `}

  img {
    width: 1.5rem;
    height: 1.5rem;
    object-fit: cover;
    border-radius: var(--border-radius);
  }
`
